export const supportedLanguages = ["en", "ar"] as const;
export type SupportedLanguage = (typeof supportedLanguages)[number];

export const rtlLanguages: SupportedLanguage[] = ["ar"];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type TranslationFunction = (key: string, ...params: any[]) => string;

export const isRTL = (language: SupportedLanguage): boolean => {
  return rtlLanguages.includes(language);
};
